import getDefaultLocale from './locale/getDefaultLocale'

export default (translatableValue?: string | Record<string, string>) => {
  if (!translatableValue) {
    return ''
  }

  const locale = useState<string>('locale.setting')

  if (typeof translatableValue === 'string') {
    return translatableValue
  }

  return translatableValue[locale.value ?? getDefaultLocale().iso]?.trim() ?? ''
}
